import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Route, useHistory, withRouter } from 'react-router';
import SummarySvg from 'images/info-circle.svg';
import ComponentsSvg from 'images/v5/icons/layers-two-01.svg';
import Loader from 'layout/atoms/Loader/Loader';
import ParameterDetails from 'layout/atoms/ParameterDetails/ParameterDetails';
import Tabs from 'layout/atoms/Tabs/Tabs';
import Grid from 'layout/molecules/Grid/Grid';
import { clearBreadcrumbs, selectLayout, setBreadcrumbs } from 'store/layoutSlice';
import { fetchWarehouseRelease, fetchWarehouseReleaseIsReady, fetchWarehouseReleaseModel, resetWarehouseReleaseDetailsState, selectWarehouseReleaseDetailsItem, selectWarehouseReleaseDetailsRefetchFlags, selectWarehouseReleaseDetailsStatus, } from 'store/warehouseReleaseDetailsSlice';
import Dashboard from 'templates/Dashboard/Dashboard';
import { getMenuLabel } from 'utils/getMenuItem';
import Components from './Components';
import SpecificationsPicker from './SpecificationsPicker';
import Summary from './Summary';
import WarehouseReleasesActions from './WarehouseReleasesActions';
function WarehouseReleaseDetails({ match }) {
    const { t } = useTranslation(['warehouseReleases', 'common']);
    const { warehouseReleaseId } = match.params;
    const dispatch = useDispatch();
    const layout = useSelector(selectLayout);
    const path = `/warehouse-releases/${warehouseReleaseId}`;
    const history = useHistory();
    const [activeTab, setActiveTab] = useState('summary');
    const status = useSelector(selectWarehouseReleaseDetailsStatus);
    const refetchFlags = useSelector(selectWarehouseReleaseDetailsRefetchFlags);
    const warehouseRelease = useSelector(selectWarehouseReleaseDetailsItem);
    // const warehouseReleaseModel = useSelector(selectWarehouseReleaseModel);
    // const { url } = useRouteMatch();
    // const warehouseReleasesUrl = url.split('/').slice(0, -1).join('/');
    useEffect(() => {
        var _a, _b;
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(fetchWarehouseRelease(warehouseReleaseId));
        }
        if ((warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.warehouseReleaseModel) && status.fetchModel === 'idle') {
            dispatch(fetchWarehouseReleaseModel((_a = warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.warehouseReleaseModel) === null || _a === void 0 ? void 0 : _a.id));
        }
        if (status.fetch === 'succeeded' &&
            (warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.warehouseReleaseModel) &&
            refetchFlags.fetchModel) {
            dispatch(fetchWarehouseReleaseModel((_b = warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.warehouseReleaseModel) === null || _b === void 0 ? void 0 : _b.id));
        }
        if (refetchFlags.fetchReady) {
            dispatch(fetchWarehouseReleaseIsReady(warehouseReleaseId));
        }
    }, [dispatch, warehouseReleaseId, warehouseRelease, status, refetchFlags]);
    useEffect(() => {
        const warehouseReleasesLabel = getMenuLabel('/warehouse-releases', t);
        const releaseName = warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.releaseId;
        dispatch(setBreadcrumbs([
            { to: '/warehouse-releases', name: warehouseReleasesLabel },
            { to: path, name: releaseName },
        ]));
        return () => {
            dispatch(clearBreadcrumbs());
        };
    }, [dispatch, t, path, warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.releaseId]);
    useEffect(() => {
        history.replace(`${path}/${activeTab}`);
        return () => {
            dispatch(resetWarehouseReleaseDetailsState);
        };
    }, [dispatch, history, path, activeTab]);
    const tabs = [
        { id: 'summary', icon: React.createElement(SummarySvg, null), label: t('summary') },
        { id: 'components', icon: React.createElement(ComponentsSvg, null), label: t('components') },
    ];
    if (status.fetch !== 'succeeded') {
        return React.createElement(Loader, null);
    }
    if (status.fetch === 'failed') {
        return React.createElement("p", null, "failed");
    }
    return (React.createElement(Dashboard, { subheader: React.createElement(ParameterDetails, { size: "xl", label: t('warehouse_release'), value: (warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.releaseId) || '-' }), subheaderButtons: warehouseRelease && React.createElement(WarehouseReleasesActions, null), tabs: React.createElement(Tabs, { size: "l", tabs: tabs, activeTab: activeTab, onClick: (e) => setActiveTab(e) }) },
        React.createElement(Grid, { vp: 12, hp: 24, gap: 0 },
            React.createElement(Route, { path: `${path}/summary` },
                React.createElement(Summary, null),
                React.createElement(Route, { path: `${path}/summary/specifications` }, layout.showModals.some((modal) => modal.name === 'warehouseReleaceSpecificationPicker') && React.createElement(SpecificationsPicker, null))),
            React.createElement(Route, { path: `${path}/components` },
                React.createElement(Components, null)))));
}
export default memo(withRouter(WarehouseReleaseDetails));
